import { MessageBox, Loading, Tooltip, Tabs, TabPane } from 'element-ui'
import { FadeTransition } from 'vue2-transitions';
import { BaseRadio, BaseCheckbox, FgInput, BaseButton, BaseDropdown, Card, StatusBadge } from 'src/components/index'
import BaseAvatar from 'src/components/BaseAvatar'
import BaseSwitch from 'src/components/BaseSwitch'
import BaseForm from 'src/components/Form/BaseForm'
import SubmitButton from 'src/components/SubmitButton'
import SidebarMenu from 'src/components/SidebarMenu'
import SectionSeparator from 'src/components/SectionSeparator'
import NavList from 'src/components/List/NavList';
import NavBackButton from 'src/components/List/NavBackButton';
import Modal from 'src/components/Modal';
const DataTable = () => import(/* webpackChunkName: administration */ 'src/components/DataTable');

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 * Ideally, only small components that are re-used many times across your application should be registered here.
 * For plugins and bigger components local registration is preferable because it will allow you to do code splitting easier :)
 */

const GlobalComponents = {
  install (Vue) {
    Vue.component(BaseAvatar.name, BaseAvatar)
    Vue.component(BaseDropdown.name, BaseDropdown)
    Vue.component(BaseCheckbox.name, BaseCheckbox)
    Vue.component(BaseRadio.name, BaseRadio)
    Vue.component(BaseButton.name, BaseButton)
    Vue.component(BaseSwitch.name, BaseSwitch)
    Vue.component(BaseForm.name, BaseForm)
    Vue.component(SubmitButton.name, SubmitButton)
    Vue.component(Card.name, Card)
    Vue.component(SidebarMenu.name, SidebarMenu)
    Vue.component(StatusBadge.name, StatusBadge)
    Vue.component(SectionSeparator.name, SectionSeparator)
    Vue.component('data-table', DataTable)
    Vue.component(FgInput.name, FgInput)
    Vue.component(NavList.name, NavList)
    Vue.component(Modal.name, Modal)
    Vue.component(Tabs.name, Tabs)
    Vue.component(TabPane.name, TabPane)
    Vue.component(NavBackButton.name, NavBackButton)
    Vue.component(FadeTransition.name, FadeTransition)
    Vue.component(Tooltip.name, Tooltip)
    Vue.prototype.$confirm = MessageBox.confirm
    Vue.use(Loading.directive)
  }
}

export default GlobalComponents
